import { isEmpty } from 'lodash';
import { FunctionComponent } from 'react';
import { Asset } from '../models/Asset';

type Props = {
    asset: Asset;
};

const EntranceMethod: FunctionComponent<Props> = ({ asset }) => {
    const entranceMethod = asset.entranceMethod;
    if (!entranceMethod) {
        return <i className="preview__default">Ange hur gästen får tillgång till resursen</i>;
    }

    const { contactName, contactInformation, otherInformation, showDescription } = entranceMethod;

    const fields: string[] = [];
    if (contactName) {
        fields.push(contactName);
    }
    if (contactInformation) {
        fields.push(contactInformation);
    }
    if (otherInformation) {
        fields.push(otherInformation);
    }
    return (
        <div>
            {!otherInformation || (otherInformation && showDescription) ? <div>{entranceMethod.description}</div> : null}
            {!isEmpty(contactName) && (
                <div>
                    {contactName}, {contactInformation}
                </div>
            )}
            {!isEmpty(otherInformation) && <div>{otherInformation}</div>}
        </div>
    );
};

export default EntranceMethod;
